module.exports = {
  RT_API: 'https://pmvx-dv1.sti.codes',
  RT_S3_ASSETS: 'https://s3.ca-central-1.amazonaws.com/dv.admin-portal',
  RT_SYNCHUB: 'https://api.sti.codes',
  RT_KEYCLOAK_AUTH_SERVER_URL: 'https://sso.sti.codes/auth',
  RT_KEYCLOAK_REALM: 1,
  RT_KEYCLOAK_CLIENTID: 'admin-portal',
};
